// @flow
import * as React from 'react';

import clsx from 'clsx';
import { FormControl, TextArea, View } from 'reshaped';

import { useTranslator } from '@gandi/translate';

import { useDragAndDrop } from 'src/Domain/BulkInput/useDragAndDrop';

import styles from './TextAreaField.module.css';

export type Props = {
  field: {
    onChange: (value: any) => void,
    onBlur: () => void,
    value: mixed,
    disabled: boolean,
    name: string,
    ref: React.RefObject<HTMLInputElement>,
  },
};
export function TextAreaField({ field }: Props): React.MixedElement {
  const { __ } = useTranslator();
  const [, setFileName] = React.useState<string>('');

  const { bind, isDragging } = useDragAndDrop({
    setDomains: field.onChange,
    setFileName,
  });

  // KeyDown event handler used to submit the bulk search form on Ctrl + Enter
  function handleTextareaKeyDown(
    evt: SyntheticKeyboardEvent<HTMLTextAreaElement>,
  ) {
    if (evt.key === 'Enter' && (evt.ctrlKey || evt.metaKey)) {
      const parentForm = evt.currentTarget.closest('form');
      const confirmButton = parentForm?.querySelector(
        'button[type="submit"]:not([disabled])',
      );
      if (confirmButton) {
        confirmButton.click();
      }
    }
  }

  return (
    // $FlowFixMe[prop-missing]
    <View
      className={clsx(styles.root, isDragging && styles.isDragging)}
      attributes={{
        ...bind,
      }}
    >
      {/* $FlowFixMe[incompatible-type] */}
      <TextArea
        name="domains"
        placeholder={__('example.com')}
        variant="faded"
        value={typeof field.value === 'string' ? field.value : ''}
        onChange={e => field.onChange(e.value)}
        inputAttributes={{
          'aria-label': __('List of domains to add'),
          autoComplete: 'off',
          onKeyDown: handleTextareaKeyDown,
          required: true,
          spellCheck: false,
        }}
      />
      <FormControl.Helper>
        {__('One domain per line. Subdomains and wildcards are accepted.')}
      </FormControl.Helper>
    </View>
  );
}
